<template>
  <div class="examination">
    <!-- 查询 -->
     <!-- <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="题目名称:">
        <el-input v-model="formInline.user" placeholder="题目名称"></el-input>
      </el-form-item>
      <el-form-item label="发布老师:">
        <el-input v-model="formInline.user" placeholder="发布老师"></el-input>
      </el-form-item>
     <el-form-item label="类型:">
        <el-select v-model="formInline.region" placeholder="类型">
          <el-option label="所有" value="0"></el-option>
          <el-option label="铸造" value="-1"></el-option>
          <el-option label="卡环" value="2"></el-option>
          <el-option label="素描" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary">查询</el-button>
      </el-form-item>
      <el-form-item label="类型:">
        <el-select v-model="formInline.region" placeholder="类型" @change="goselect">
          <el-option label="全部" :value="0"></el-option>
          <el-option label="已完成" :value="1"></el-option>
          <el-option label="未完成" :value="2"></el-option>
        </el-select>
      </el-form-item>
    </el-form>-->
    <div>
       <el-row >
         <el-col :span="2">展示类型：
         </el-col>
         <el-col :span="4">
            <el-radio-group v-model="radio"  @change="getlist()">
                  <el-radio :label="1">班级数据</el-radio>
                  <el-radio :label="2">群组数据</el-radio>
            </el-radio-group>
         </el-col>
       </el-row>
    </div>
      <search @searchhandle="goselect"></search>
    <!--  <el-radio-group v-model="radio"  @change="getlist()">
        <el-radio :label="1">班级展示</el-radio>
        <el-radio :label="2">群组展示</el-radio>
      </el-radio-group>
    <search @searchhandle="goselect"></search>-->
    <ul class="taskList" v-loading="loading" v-if="tabledata.length>0">
    <!-- 作业列表 -->
      <li class="taskItem" v-for="(item,index) in tabledata" :key="item.id">
        <span class="sign" v-show="item.cate.id==1">{{item.cate.name}}</span>
        <span class="sign kh" v-show="item.cate.id==2">{{item.cate.name}}</span>
        <span class="sign zz" v-show="item.cate.id==3">{{item.cate.name}}</span>
        <template v-if="!item.isstore">


           <el-button type="primary" size="mini" class="btn" @click="submitbtn(item,2)" v-if="!item.status">{{item.cate.id==3?"提交考试":"开始考试"}}</el-button>
          <el-button type="info" size="mini" class="btn" @click="submitbtn(item,2)" v-else>已提交</el-button>
        </template>
        <template v-else>
          <el-button type="success" size="mini" class="btn1" @click="golook(item)">查看成绩</el-button>
        </template>
        <div class="contents">
          <img :src="GLOBAL.BASE_URL+item.detail" class="detailimg" v-if="item.detail&&item.is_start">
          <img src="../../../static/images/default1.png" class="detailimg" v-else>
          <div class="leftwrap">
            <div class="firstdiv">
              <div class="taskname">{{item.title}}</div>
              <div class="teachername teachername1">发布：{{item.author}}</div>

            </div>
            <div class="firstdiv">
              <div class="teachername teachername2">开始时间：{{item.start_time}}</div>
              <div class="teachername  teachername2">结束时间：{{item.end_time}}</div>
              <div class="teachername teachername1">时长：{{item.test_time}}</div>
               <div class="teachername teachername2" v-show="item.created_at1">提交时间：{{item.created_at1}}</div>
            </div>
            <!-- 素描 -->
            <div class="twodiv" v-if="item.is_start">
              <div class="leftdiv">
                <div class="tit" >题目描述:</div>
                <div class="condiv">
                  {{item.description}}
                </div>
              </div>
            </div>
            <div class="twodiv">
              <div class="leftdiv" v-if="item.cate.id==3" :class="{'leftdiv1':item.cate.id==3}">
                <div class="tit">素描图片:</div>
                <div class="condiv">
                  <el-upload class="upload-demo" :action="uploadUrl" :on-preview="handlePictureCardPreview"  :on-exceed="exceed" :before-upload="beforeAvatarUpload" :file-list="item.student_answer1" :limit="2"   :on-success="(res, file, fileList)=>{return handleInfoSuccess(res, file, fileList, index)}"  :on-remove="(file, fileList)=>{return handleInfoRemove(file, fileList, index)}" list-type="picture-card">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </div>
              </div>

              <div class="leftdiv" v-if="item.cate.id==3" :class="{'leftdiv2':item.cate.id==3}">
                <div class="tit"> 相关理解:</div>
                <div class="condiv">
                  <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="item.textarea">
                  </el-input>
                </div>
              </div>
              <!-- 卡环图片 -->
              <div class="leftdiv" v-if="item.cate.id==2&&item.student_answer1&&item.student_answer1.length>0" :class="{'leftdiv1':item.cate.id==2}">
                <div class="tit">卡环图片:</div>
                <div class="condiv">
                  <!-- :file-list="item.student_answer" -->
                  <!-- :data-msg="item" ref="dataMsg" -->
                  <template v-if="item.student_answer1&&item.student_answer1.length>0">
                  <img :src="item.url" @click="handlePictureCardPreview(item)" alt="" v-for="item in item.student_answer1"  style="width:148px;height:148px;border-radius: 6px; margin-right:8px;margin-bottom:8px;border: 1px solid #c0ccda">
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div style="text-align: center;font-size:20px" v-else>暂无数据</div>
    <!-- <div style="text-align: right">
      <el-pagination background @current-change="pageCurrentChange" :page-count="pageform.pages" :current-page="pageform.pageNum" layout="prev, pager, next" :total="pageform.total" :page-size='3'>
      </el-pagination>
    </div> -->
     <pagelist @currentchange="pagehandle"  :page-count="pageform.pages" :current-page="pageform.pageNum"  :total="pageform.total" :page-size="pageform.pageSize"></pagelist>
  </div>
</template>

<script>
import search from './search'
import task from './task'
import pagelist from './pagelist'
export default {
   mixins: [task],
  props: {

  },
  components:{
search,
pagelist
  },
  data() {
    return {
      region:'',
      radio:1,
      params: {
        class_id: this.$store.getters.getUserInfo.class_id,
        page_size: 3,
        page: 1,
        type: 2,
         cate:''
      },
    };
  },
  computed: {

  },
  created() {
    //this.gettasklist()
  },
  methods: {
    getlist(){
      this.params.show=this.radio;
      this.gettasklist()
    },
     goselect(data) {
      this.params.show=this.radio;
      var { region,cate} = data
      this.region = region
      // console.log(data)

      if (region == 0) {
         this.params.cate=cate
        this.gettasklist()
      }  else {
        this.params = {
          page_size: 3,
          page: 1,
          type: 2,
          class_id: this.$store.getters.getUserInfo.class_id,
          cate:cate,
          sort:region>2?'score':'finish'
        }

        this.gettypelist(region)
      }
    },
    // beforeAvatarUpload(file) {
    //   const isLt2M = file.size / 1024 / 1024 < 2;
    //   if (!isLt2M) {
    //     this.$message.error('上传头像图片大小不能超过 2MB!');
    //   }
    //   return isLt2M;
    // },
    //  // 上传图片超出最大限制
    // exceed(files,fileList){
    //     alert("最多只能上传2张图片！")
    // },
    // goselect(val) {
    //   if (val == 0) {
    //     this.gettasklist()
    //   } else {
    //     this.gettypelist(val)
    //   }
    // },
    // //查看成绩
    // golook(item) {
    //   this.$router.push({ path: '/ucenter/examarrangement', query: { task_id: item.id, type: item.cate.id } })
    // },
    // //全部列表
    // gettasklist() {
    //   this.$http.taskclass(this.params)
    //     .then(res => {
    //       if (res.code != 0) {
    //         this.loading = false;
    //         var tabledata = res.data.task;
    //         this.pageform.pages = res.data.allPage;
    //         this.pageform.total = res.data.allCount;
    //         for (var i = 0; i < tabledata.length; i++) {
    //           tabledata[i].textarea = ""
    //           tabledata[i].status = false
    //           tabledata[i].isstore = false
    //           this.gettaskstatus(tabledata[i])
    //         }
    //         this.tabledata = tabledata

    //       } else {
    //         this.$message.error(res.message)
    //       }

    //     })
    // },
    // //已完成未完成
    // gettypelist(val) {
    //   this.params = {
    //     page_size: 3,
    //     page: 1,
    //     type: 2,
    //     class_id: this.$store.getters.getUserInfo.class_id,
    //   }
    //   this.$http.get_student_record(this.params)
    //     .then(res => {
    //       if (res.code != 0) {
    //         this.loading = false;
    //         if (val == 1) {
    //           var tabledata = res.data.finish.data;
    //           this.pageform.pages = res.data.finish.page;
    //           this.pageform.total = res.data.finish.count;
    //           for (var i = 0; i < tabledata.length; i++) {
    //             tabledata[i].textarea = ""
    //             tabledata[i].isstore = false
    //             tabledata[i].status = false

    //             this.gettaskstatus(tabledata[i])
    //           }
    //         } else {
    //           var tabledata = res.data.unfinish.data;
    //           this.pageform.pages = res.data.unfinish.page;
    //           this.pageform.total = res.data.unfinish.count;
    //           for (var i = 0; i < tabledata.length; i++) {
    //             tabledata[i].textarea = ""
    //             tabledata[i].isstore = false
    //             tabledata[i].status = false
    //             this.gettaskstatus(tabledata[i])
    //           }
    //         }
    //         this.tabledata = tabledata

    //       } else {
    //         this.$message.error(res.message)
    //       }

    //     })
    // },

    // //素描提交
    // smbtn(item) {

    //   console.log(item)

    //   if (item.student_answer.length > 0) {
    //     this.$confirm('你是否确定提交作业?', '提示', {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     }).then(() => {

    //       var params = {
    //         task_id: item.id,
    //         student_answer: item.student_answer,
    //         student_des: item.textarea
    //       }
    //       this.$http.insert_student_record(params)
    //         .then(res => {
    //           if (res.code == 200) {
    //             this.$alert('提交成功', '提示', {
    //               confirmButtonText: '确定',
    //               callback: action => {
    //                 if (this.formInline.region == 0) {
    //                   this.gettasklist()
    //                 } else {
    //                   this.gettypelist(this.formInline.region)
    //                 }
    //               }

    //             });

    //           } else {
    //             this.$message.error(res.message)
    //           }

    //         })
    //     }).catch(() => {
    //       this.$message({
    //         type: 'info',
    //         message: '已取消'
    //       });
    //     });
    //   } else {
    //     this.$message({
    //       message: '请上传素描图片!',
    //       type: 'warning'
    //     });
    //   }

    // },
    // //作业状态
    // gettaskstatus(item, i) {
    //   this.$http.taskstatus({ task_id: item.id })
    //     .then(res => {
    //       if (res.code == 200) {
    //         if (res.data) {
    //           item.status = true
    //           if (res.data.teacher_data) {

    //             item.isstore = true

    //           }
    //           if (res.data.student_des) {
    //             item.textarea = res.data.student_des
    //           }
    //           var arr = []
    //           if (res.data.student_answer.length > 0) {
    //             for (var i = 0; i < res.data.student_answer.length; i++) {
    //               var imgObject = {
    //                 "url": this.GLOBAL.BASE_URL + res.data.student_answer[i],
    //                 "name":i
    //               }
    //               arr.push(imgObject)
    //             }
    //             item.student_answer1 = arr
    //             item.student_answer = res.data.student_answer
    //           } else {
    //             item.student_answer1 = []
    //             item.student_answer = []
    //           }

    //         } else {
    //           item.status = false
    //           item.isstore = false
    //         }
    //       } else {

    //         this.$message.error(res.message)
    //       }

    //     })
    // },

    // //提交
    // submitbtn(item) {
    //   var nowdate = new Date().getTime()
    //   var enddate = new Date(item.end_time).getTime();
    //   var startdate = new Date(item.start_time).getTime();
    //   if ((nowdate > enddate) || (startdate > nowdate)) {
    //     // this.tabledata[i].statustime = true;
    //     this.$message({
    //       message: '不在考试时间范围內！',
    //       type: 'warning'
    //     });
    //   } else {
    //     //卡环
    //     if (item.cate.id == 2) {
    //       if (item.cate.url) {
    //         window.location.href =
    //           item.cate.url +
    //           "?data=" + this.$store.getters.getUserInfo.id + '+' + this.$store.getters.getUserInfo.realname + '+Exam+' + item.tooth_num + '+' + item.id
    //       } else this.$message("暂未开放");

    //     } else if (item.cate.id == 3) {
    //       //素描
    //       this.smbtn(item);
    //     } else {
    //       //非卡环
    //       window.location.href =
    //         item.cate.url +
    //         "?data=" + this.$store.getters.getUserInfo.id + '+' + this.$store.getters.getUserInfo.realname + '+Exam+' + item.id;
    //     }
    //   }

    // },

    // pageCurrentChange(val, e, form, jobExpLabel, pageform, searchVal) {
    //   this.pageform.pageNum = val;
    //   this.params.page = val;
    //   this.gettasklist();
    // },
    //  // 产品详情 图片上传成功
    // handleInfoSuccess(res, file, fileList,index) {
    //   this.tabledata[index]['student_answer'].push(res.data)
    //   var imgObject = {
    //     "url": this.GLOBAL.BASE_URL + res.data,
    //     "name":file.name
    //   }
    //   this.tabledata[index]['student_answer1'].push(imgObject)
    //   // this.ImgList.push(res.data)
    //   // console.log( this.ImgList)

    //  // console.log(this.tabledata[index])
    //   // this.$forceUpdate()
    // },
    // handleInfoRemove(file, fileList,index) {
    //     var arr = this.tabledata[index]['student_answer1'];
    //     for (var i = 0; i < arr.length; i++) {
    //       if (arr[i].name == file.name) {
    //         this.tabledata[index]['student_answer'].splice(i, 1)
    //         this.tabledata[index]['student_answer1'].splice(i, 1)
    //       }
    //     }
  }




};
</script>

<style  lang="less">
.examination {
  .taskList {
    list-style: none;
    margin-bottom: 20px;

    .taskItem {
      position: relative;
      border: 1px solid #ebeef5;
      background-color: #fff;
      color: #303133;
      //   height: 200px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      margin-bottom: 20px;
      .sign {
        display: inline-block;
        position: absolute;
        top: 0;
        left: 0;
        width: 60px;
        line-height: 30px;
        height: 30px;
        background: #fd4e4e;
        color: #fff;
        font-size: 14px;
        text-align: center;
        border-radius: 0 0 10px 0;
      }
      .kh {
        background: #26ceaf;
      }
      .zz {
        background: #5b81ea;
      }
      .btn {
        position: absolute;
        top: 0;
        right: 0;
      }
      .btn1 {
        position: absolute;
        top: 40px;
        right: 0;
      }
      .detailimg {
        width: 240px;
        float: left;
      }
      .leftwrap {
        margin-left: 250px;
      }
      .contents {
        padding: 20px;
        padding-top: 40px;
        // height: 172px;
        box-sizing: border-box;
        overflow: hidden;
      }
      .firstdiv {
        overflow: hidden;
        margin-bottom: 10px;
        div {
          width: 40%;
        }
        .taskname {
          float: left;
          color: #5193f7;
          font-size: 16px;
          font-weight: bold;
        }
        .teachername {
          color: #303133;
          font-size: 15px;
          float: left;
        }
        .teachername1 {
          // width: 15%;
          width: 120px;
        }
        .teachername2 {
          width: 240px;
        }
      }
      .twodiv {
        // padding-top: 20px;
        overflow: hidden;
        .leftdiv {
          .tit {
            font-size: 15px;
            margin-bottom: 10px;
          }
          // width: 33.33%;
          width: 100%;
          float: left;
          .condiv {
            padding-right: 10px;
            // line-height: 30px;
            font-size: 15px;
            // display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
            // -webkit-line-clamp: 2; /*显示的行数；如果要设置2行加...则设置为2*/
            // overflow: hidden;
            // text-overflow: ellipsis; /* 溢出用省略号*/
            // /*! autoprefixer: off */
            // -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
            // /* autoprefixer: on */
          }
        }

        .leftdiv1 {
          // width: 70%;
          width: auto;
          margin-right: 20px;
        }
        .leftdiv2 {
          width: auto;
          width: 30%;
        }
      }
    }
  }
  .el-upload--picture-card {
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 148px;
    height: 148px;
    line-height: 146px;
    vertical-align: top;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/assessment/examination.vue